import dayjs from 'dayjs';
dayjs.locale('ja');

/**
 * 日付文字列を日付オブジェクトに変換
 * @param date
 * @param separator
 */
export const stringToDate = (date: string) => {
  if (!date) return false;
  if (typeof date !== 'string') throw new TypeError('date is empty');
  return dayjs(date).toDate();
};

export default stringToDate;
